/**
 * The guest's saved outfits: what a logged-out visitor has hearted on an
 * outfit page, held in the browser until they sign in and it merges into their
 * account. Mirrors `guestWishlist.ts` — ids only, never a snapshot of the
 * look, for the same reason: a saved outfit may sit here for weeks.
 */

// A guard against a runaway or hand-edited store, not a product limit.
const MAX_ENTRIES = 200

/** Read defensively: anything malformed degrades to an empty list rather than throwing. */
export function parseGuestSavedLooks(raw: unknown): string[] {
  if (typeof raw !== 'string' || raw === '')
    return []
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed))
      return []
    const ids: string[] = []
    for (const value of parsed) {
      const id = typeof value === 'string' || typeof value === 'number' ? String(value) : ''
      if (id && !ids.includes(id))
        ids.push(id)
      if (ids.length >= MAX_ENTRIES)
        break
    }
    return ids
  }
  catch {
    return []
  }
}

export function serializeGuestSavedLooks(ids: readonly string[]): string {
  return JSON.stringify(ids.slice(0, MAX_ENTRIES))
}
